import { render, staticRenderFns } from "./ModalTip.vue?vue&type=template&id=2abeb1ff&scoped=true"
import script from "./ModalTip.vue?vue&type=script&lang=js"
export * from "./ModalTip.vue?vue&type=script&lang=js"
import style0 from "./ModalTip.vue?vue&type=style&index=0&id=2abeb1ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abeb1ff",
  null
  
)

export default component.exports